var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMouseDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 53,
    viewBox: "0 0 18 53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9 1a8 8 0 0 0-8 8v9a8 8 0 1 0 16 0V9a8 8 0 0 0-8-8zm0-1a9 9 0 0 1 9 9v9a9 9 0 0 1-18 0V9a9 9 0 0 1 9-9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9 26h1v26.08H9z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMouseDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mouse-down.77fca64d.svg";
export { ForwardRef as ReactComponent };